/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PlanForConduct,
  PlanForConductDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiPlanForConductProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<PlanForConduct>(
      {url: `/api/PlanForConduct/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiPlanForConductProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/PlanForConduct/${projectId}`
    ] as const;
    }


export const getGetApiPlanForConductProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPlanForConductProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>> = ({ signal }) => getApiPlanForConductProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPlanForConductProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>>
export type GetApiPlanForConductProjectIdQueryError = ErrorType<unknown>


export function useGetApiPlanForConductProjectId<TData = Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlanForConductProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiPlanForConductProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPlanForConductProjectId<TData = Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlanForConductProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiPlanForConductProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPlanForConductProjectId<TData = Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPlanForConductProjectId<TData = Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlanForConductProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPlanForConductProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiPlanForConduct = (
    planForConductDto?: BodyType<PlanForConductDto>,
 signal?: AbortSignal
) => {


      return customInstance<PlanForConduct>(
      {url: `/api/PlanForConduct`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: planForConductDto, signal
    },
      );
    }




export const getPutApiPlanForConductMutationKey = () => ['putApiPlanForConduct'] as const;

export const getPutApiPlanForConductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPlanForConduct>>, TError,PutApiPlanForConductMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiPlanForConduct>>, TError,PutApiPlanForConductMutationVariables, TContext> => {

const mutationKey = getPutApiPlanForConductMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiPlanForConduct>>, PutApiPlanForConductMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiPlanForConduct(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiPlanForConductMutationResult = NonNullable<Awaited<ReturnType<typeof putApiPlanForConduct>>>
    export type PutApiPlanForConductMutationBody = BodyType<PlanForConductDto> | undefined
    export type PutApiPlanForConductMutationError = ErrorType<unknown>
    export type PutApiPlanForConductMutationVariables = {data?: BodyType<PlanForConductDto>}

    export const usePutApiPlanForConduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPlanForConduct>>, TError,PutApiPlanForConductMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiPlanForConduct>>,
        TError,
        PutApiPlanForConductMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiPlanForConductMutationOptions(options), queryClient);
    }
